// GENERATED FILE — do not edit by hand.
// Run `yarn generate:cards` after changing frontend/static/cards/ or
// cards/labels.json. See cards/README.md.

/** Every card face committed to frontend/static/cards/, rendered as /cards/{id}.webp */
export type CardProductId =
  | 'amex_platinum'
  | 'barclays_jetblue'
  | 'barclays_jetblue_premier'
  | 'capital_one_venture_x'
  | 'chase_freedom'
  | 'chase_freedom_unlimited'
  | 'chase_sapphire_preferred'
  | 'chase_sapphire_reserve'
  | 'chase_united_gateway'
  | 'citi_aadvantage_mileup'
  | 'citi_aadvantage_platinum_select'
  | 'citi_custom_cash'
  | 'citi_strata_premier'
  | 'citi_thankyou_preferred';

export type CardProductOption = {value: CardProductId; label: string};

export const CARD_PRODUCT_OPTIONS: readonly CardProductOption[] = [
  {value: 'amex_platinum', label: 'American Express Platinum'},
  {value: 'barclays_jetblue', label: 'Barclays JetBlue Card'},
  {value: 'barclays_jetblue_premier', label: 'Barclays JetBlue Premier Card'},
  {value: 'capital_one_venture_x', label: 'Capital One Venture X'},
  {value: 'chase_freedom', label: 'Chase Freedom'},
  {value: 'chase_freedom_unlimited', label: 'Chase Freedom Unlimited'},
  {value: 'chase_sapphire_preferred', label: 'Chase Sapphire Preferred'},
  {value: 'chase_sapphire_reserve', label: 'Chase Sapphire Reserve'},
  {value: 'chase_united_gateway', label: 'Chase United Gateway'},
  {value: 'citi_aadvantage_mileup', label: 'Citi AAdvantage MileUp'},
  {value: 'citi_aadvantage_platinum_select', label: 'Citi AAdvantage Platinum Select'},
  {value: 'citi_custom_cash', label: 'Citi Custom Cash'},
  {value: 'citi_strata_premier', label: 'Citi Strata Premier'},
  {value: 'citi_thankyou_preferred', label: 'Citi ThankYou Preferred'},
];

const LABELS: ReadonlyMap<string, string> = new Map(
  CARD_PRODUCT_OPTIONS.map((option) => [option.value, option.label]),
);

/**
 * Narrow an arbitrary string — a value read from the database, which is typed
 * as a plain string — to a known CardProductId.
 */
export const isCardProductId = (
  value: string | null | undefined,
): value is CardProductId => value != null && LABELS.has(value);

/** Display name for a product slug; null for unknown or empty values. */
export const cardProductLabel = (
  value: string | null | undefined,
): string | null => (value == null ? null : (LABELS.get(value) ?? null));

/**
 * Content tag per face: the first 8 hex of the file's sha256. Same reason as
 * logoOptions.ts — the slug is stored in the database, so the filename can
 * never carry the hash, and the tag rides in the query string instead so the
 * server can serve /cards/ as immutable.
 */
const CARD_VERSIONS: ReadonlyMap<string, string> = new Map([
  ['amex_platinum', '6f20e7f9'],
  ['barclays_jetblue', '85d65612'],
  ['barclays_jetblue_premier', 'b2d4f8c3'],
  ['capital_one_venture_x', 'de63c64f'],
  ['chase_freedom', '25cdae6a'],
  ['chase_freedom_unlimited', '072437b8'],
  ['chase_sapphire_preferred', '2fb56991'],
  ['chase_sapphire_reserve', '17d64910'],
  ['chase_united_gateway', '2efeaae8'],
  ['citi_aadvantage_mileup', 'a8f9b363'],
  ['citi_aadvantage_platinum_select', '9063a5f8'],
  ['citi_custom_cash', 'a5a86bdd'],
  ['citi_strata_premier', 'b9d5d4b6'],
  ['citi_thankyou_preferred', '4c01fa27'],
]);

/** URL for a card face, tagged with the file's content hash. */
export const cardArtUrl = (product: string): string => {
  const version = CARD_VERSIONS.get(product);
  return `/cards/${product}.webp${version === undefined ? '' : `?v=${version}`}`;
};
